import PATHS from 'constants/paths';
import { lazy } from 'react';
import { IsNotAuthenticated } from './IsNotAuthenticatedRoute';

// Not authenticated
const SignUp = lazy(() => import('views/NewAuthorizations/NewSignUp'));
const SignIn = lazy(() => import('views/NewAuthorizations/NewSignIn'));
const ForgotPassword = lazy(() => import('views/NewAuthorizations/ForgotPassword'));
const ResetPassword = lazy(() => import('views/NewAuthorizations/ResetPassword'));
const ActivateAccount = lazy(() => import('views/Dashboard/InviteNewMembers/RegistrationInviteUser/ActivateAccount'));
const TwoFactorAuthViaSMS = lazy(() => import('views/NewAuthorizations/2FAViaSMS'));
const SignIn2fa = lazy(() => import('views/NewAuthorizations/SignIn2fa'));
const RequestDemo = lazy(() => import('views/RequestDemo'));

const router = [
  {
    element: <ActivateAccount />,
    path: PATHS.ACTIVATE_ACCOUNT,
  },
  {
    element: <SignUp />,
    path: PATHS.SIGN_UP,
  },
  {
    element: <SignIn />,
    path: PATHS.SIGN_IN,
  },
  {
    element: <SignIn />,
    path: PATHS.VERIFY_EMAIL,
  },
  {
    element: <ForgotPassword />,
    path: PATHS.FORGOT_PASSWORD,
  },
  {
    element: <ResetPassword />,
    path: PATHS.RESET_PASSWORD,
  },
  {
    element: <TwoFactorAuthViaSMS />,
    path: PATHS.TWO_FA_VIA_SMS,
  },
  {
    element: <SignIn2fa />,
    path: PATHS.VERIFY_TWO_FA,
  },
  {
    element: <RequestDemo />,
    path: PATHS.REQUEST_DEMO,
  },
];

const notAuthenticatedRoute = (isAuth) =>
  router.map((e) => ({
    ...e,
    element: <IsNotAuthenticated isAuth={isAuth}>{e.element}</IsNotAuthenticated>,
  }));

export default notAuthenticatedRoute;
